import axios from 'axios'
import { CONFIG } from '../config/Config'
import { SESSION_EXPIRED_EVENT } from './events'

let refreshPromise = null
const refreshSubscribers = []

const subscribeToRefresh = (callback) => {
  refreshSubscribers.push(callback)
}

const notifyRefreshSubscribers = (success) => {
  refreshSubscribers.forEach(callback => callback(success))
  refreshSubscribers.length = 0
}

export const refreshAccessToken = async () => {
  if (refreshPromise) {
    return refreshPromise
  }

  refreshPromise = new Promise((resolve, reject) => {
    axios.post(
      `${CONFIG.API_BASE_PATH}/refresh`,
      {},
      { withCredentials: true }
    )
    .then((response) => {
      if (response.status === 200) {
        console.debug('Token refreshed successfully')
        notifyRefreshSubscribers(true)
        resolve(true)
      } else {
        console.warn('Token refresh failed with status:', response.status)
        handleSessionExpiration()
        notifyRefreshSubscribers(false)
        resolve(false)
      }
    })
    .catch((error) => {
      console.warn('Token refresh failed:', error.message)

      // Any error during token refresh means the session cannot be recovered
      // This includes 401 (refresh token expired), network errors, timeouts, etc.
      // After long idle periods, we should always trigger session expiration
      handleSessionExpiration()

      notifyRefreshSubscribers(false)
      reject(error)
    })
    .finally(() => {
      refreshPromise = null
    })
  })

  return refreshPromise
}

export const handleSessionExpiration = () => {
  console.warn('Session expired - dispatching event')
  
  // Dispatch session expired event
  const event = new CustomEvent(SESSION_EXPIRED_EVENT)
  window.dispatchEvent(event)
}

// Axios response interceptor to handle token refresh on 401 responses
export const setupTokenInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config

      const isRefreshRequest = originalRequest.url?.includes('/refresh')
      if (error.response?.status === 401 && !originalRequest._retry && !isRefreshRequest) {
        originalRequest._retry = true

        try {
          await refreshAccessToken()
          return axios(originalRequest)
        } catch (refreshError) {
          return Promise.reject(refreshError)
        }
      }

      return Promise.reject(error)
    }
  )
}
